import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ErrorTooltip } from '../../components/ErrorTooltip/ErrorTooltip';
import { getGlobalErrorMessage } from '../../selectors';
import { DEFAULT_ERROR_VISIBLE_TIME } from '../../constants/errors';
import { setGlobalError } from '../../actions/globalError';

export function ErrorTooltipContainer() {
  const errorMessage = useSelector(getGlobalErrorMessage);
  const dispatch = useDispatch();

  React.useEffect(() => {
    setTimeout(() => {
      dispatch(setGlobalError(null));
    }, DEFAULT_ERROR_VISIBLE_TIME);
  }, [dispatch, errorMessage]);

  if (!errorMessage) {
    return null;
  }

  return <ErrorTooltip text={errorMessage} />;
}
